import { useEffect } from "react";
import Header from "../../components/AdminPortal/Header/Header";
import VideosComponent from "../../components/AdminPortal/Videos/Videos";

export default function Videos() {
  useEffect(() => {
    document.title = "Videos - LWS Learning Portal";
  }, []);
  return (
    <>
      <Header />
      <section className="py-6 bg-primary">
        <div className="mx-auto max-w-full px-5 lg:px-20">
          <VideosComponent />
        </div>
      </section>
    </>
  );
}
